import React from 'react'
import PropTypes from 'prop-types'

export default function OrderWrap ({ children }) {
    return (
        <div className={'mtt-order-wrap'}>
            { children }
        </div>
    )
}

OrderWrap.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.string])
}